import { SearchOutlined } from "@ant-design/icons";
import { Select } from "antd";
import React from "react";

interface ShippingPreferencesSearchProps {
  carrierOptions: string[];
  addCarrierFilter: (carrierName: string) => void;
}

const ShippingPreferencesSearch: React.FC<ShippingPreferencesSearchProps> = ({ carrierOptions, addCarrierFilter }) => {
  return (
    <Select
      showSearch
      suffixIcon={<SearchOutlined />}
      onChange={addCarrierFilter}
      placeholder="Add Carrier"
      optionFilterProp="children"
      filterOption={(input, option) =>
        (option?.label?.toString().toLocaleLowerCase() ?? "").includes(input.toLocaleLowerCase())
      }
      filterSort={(optionA, optionB) =>
        (optionA?.label?.toString() ?? "")
          .toLowerCase()
          .localeCompare((optionB?.label?.toString().toLocaleLowerCase() ?? "").toLowerCase().toLocaleLowerCase())
      }
      options={carrierOptions.map((carrierOption) => {
        return {
          value: carrierOption,
          label: carrierOption,
        };
      })}
    ></Select>
  );
};

export default ShippingPreferencesSearch;
